export const getRegistrationRoute = moduleUrlId => `/main/registration/${moduleUrlId}/selection`;

export const getRegistrationPublicRoute = moduleUrlId =>
	`/public/registration/${moduleUrlId}/selection?public_embed=1`;
